import { ChangeDetectionStrategy, Component, input, output, viewChild } from '@angular/core';
import { PopoverRightDirective, PrimeButtonComponent } from '@pinnakl/shared/ui/prime';
import { Popover } from 'primeng/popover';

@Component({
  selector: 'lib-outlook-user-profile',
  imports: [Popover, PopoverRightDirective, PrimeButtonComponent],
  templateUrl: './outlook-user-profile.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'tw:relative' },
})
export class OutlookUserProfileComponent {
  private readonly menu = viewChild.required(Popover);
  readonly disabled = input(false);
  readonly logoutRequested = output<void>();

  close(): void {
    this.menu().hide();
  }
}
